import React from "react";
import Button from "@material-ui/core/Button";

class ActionButton extends React.Component {

    render() {
        return (
            <div>
                {
                    this.props.linkNewItem &&
                    <Button
                        variant="contained"
                        onClick={() => this.props.history.push(this.props.linkNewItem)}
                        color="primary"
                    > Nieuw</Button>
                }
                {
                    this.props.handleNew &&
                    <Button
                        variant="contained"
                        onClick={this.props.handleNew}
                        color="primary"
                    > Nieuw</Button>
                }
                {
                    this.props.handleSave &&
                    <Button
                        variant="contained"
                        onClick={this.props.handleSave}
                        color="primary"
                    > Opslaan</Button>
                }
                {this.props.itemleft}
            </div>
        )
    }
}
export default ActionButton